package com.mps.asc_app.data.user

enum class UserRole {
    MEMBER,
    TRAINER,
    ADMIN,
}

